export default __webpack_public_path__ + "static/media/Bed, Red.46732b78.png";